import { Enums } from '@configur-tech/upit-core-types';
import { IntegrationConfigItem } from '../../services/integration/IntegrationConfigService';

const InitialIntegrationConfig: IntegrationConfigItem = {
  accessLevel: Enums.AccessLevel.MANAGE,
  entity: {
    organisationId: '',

    name: '',

    description: '',

    integrationTemplateId: '',

    access: {
      manage: {
        organisation: [],
        team: [],
        user: [],
      },
      edit: { organisation: [], team: [], user: [] },
      view: { organisation: [], team: [], user: [] },
    },
  },
};

export default InitialIntegrationConfig;
